import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
import { Grid, Stack } from '@mui/material';

class Breadcrumbs extends Component {
    render() {

        const itemsLength = this.props.breadcrumbItems ? this.props.breadcrumbItems.length : null;

        return (
            <React.Fragment>
                <Grid container className='page-title-box' spacing={1} pb={{xs: 1, sm: 2}}>
                    <Grid item xs={12} sm={4}>
                        <h4 className="mb-0">{this.props.t(this.props.title)}</h4>
                    </Grid>
                    {
                        this.props.breadcrumbItems &&
                        <Grid item xs={12} sm={8} display={"flex"} justifyContent={{xs: "start", sm: "end"}}>
                            <Breadcrumb listClassName="m-0" style={{fontSize: "12px"}}>
                                {
                                    this.props.breadcrumbItems.map((item, key) =>
                                        key + 1 === itemsLength ?
                                            <BreadcrumbItem key={key} active>{this.props.t(item.title)}</BreadcrumbItem>
                                            : <BreadcrumbItem key={key} ><Link to={item.link}>{this.props.t(item.title)}</Link></BreadcrumbItem>
                                    )
                                }
                            </Breadcrumb>
                        </Grid>
                    }
                </Grid>
            </React.Fragment>
        );
    }
}

export default withTranslation()(Breadcrumbs);